import { Component, Input, OnInit } from '@angular/core';
import { EYesNo } from '../../../../shared/models/types.enum';
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../../spinner/spinner.component';
import { RMSRecordReviewService } from '../../../../shared/services/rmsRecordReview.service';
import { IThreatAssessmentTeam } from '../../../../shared/models/contact';
import { ContactsService } from '../../../../shared/services/contact.service';
import { UserDataService } from '../../../../shared/services/auth/userData.service';
import { CaseClosingSummaryService } from '../../../../shared/services/caseClosingSummary.service';

@Component({
  selector: 'review-case-closing-summary',
  standalone: true,
  imports: [
    CommonModule,
    SpinnerComponent
  ],
  templateUrl: './review-case-closing-summary.component.html',
  styleUrl: './review-case-closing-summary.component.css'
})
export class ReviewCaseClosingSummaryComponent implements OnInit {
  
  @Input() caseId: string | null = null;
  
  yesNo = EYesNo;
  caseClosingSummary: any | null = null;

  usersList: IThreatAssessmentTeam[] = [];
  currentCaseId: string | null = null;
  currentBuildingId: string | null = null;
  userFillingForm: IThreatAssessmentTeam | null = null;
  messageModal: string | null = null;

  loading: boolean = false;
  
  sections = [
    {
      sectionName: "Case Manager Information",
      children: [
        {
          type: 'string',
          questionText: "Person filling out form:",
          answer: "user_filling_form_fullname"
        },
        {
          type: 'date',
          questionText: "Form date started:",
          answer: "start_date"
        },
        {
          type: 'string',
          questionText: "Form time started:",
          answer: "start_time"
        }
      ]
    },
    {
      sectionName: "Threat Assessment Case Disposition",
      children: [
        {
          type: 'date',
          questionText: "Date of Case Closing:",
          answer: "closing_date"
        },
        {
          type: 'string',
          questionText: "Case Disposition and Closing Notes:",
          answer: "case_disposition_closing_notes"
        }
      ]
    },
    {
      sectionName: "Official Signature(s)",
      children: [
        {
          type: 'string',
          questionText: "Signature:",
          answer: "user_signature_name"
        },
        {
          type: 'string',
          questionText: "Name:",
          answer: "user_fullname"
        },
        {
          type: 'string',
          questionText: "Email address:",
          answer: "user_email"
        },
        {
          type: 'string',
          questionText: "Title:",
          answer: "user_title"
        },
        {
          type: 'string',
          questionText: "Workphone:",
          answer: "user_workphone"
        },
        {
          type: 'datetime',
          questionText: "Date & Time:",
          answer: "signed_date_time"
        }
      ]
    }
  ];

  constructor(
    private userDataService: UserDataService,
    private caseClosingSummaryService: CaseClosingSummaryService,
    private contactsService: ContactsService
  ) { }

  ngOnInit(): void {
    this.currentBuildingId = this.userDataService.getBuildingId();
    this.userFillingForm = this.usersList.find(contact => contact.user_id === Number(this.caseClosingSummary.user_filling_form_id)) || null;
    this.loadCaseClosingSummary();
  }

  loadCaseClosingSummary(): void {
    if (this.caseId) {
      this.loading = true;      
      this.caseClosingSummaryService.getCaseClosingSummaryByCaseId(this.caseId).subscribe({
        next: (response) => {
          this.caseClosingSummary = response;
          this.loading = false;
          this.loadUsers();
        },
        error: (error) => {
          console.error('Error fetching Case Closing Summary:', error);
          this.loading = false;
        }
      });
    }
  }

  // load all Contacts
  loadUsers(): void {
    this.loading = true;
    this.contactsService.getUsers(this.currentBuildingId!).subscribe({
      next: (users: IThreatAssessmentTeam[]) => {
        this.usersList = users;
        if (this.usersList.length > 0) {
          this.userFillingForm = this.usersList.find(contact => contact.user_id === Number(this.caseClosingSummary.user_filling_form_id)) || null;
        }
        this.loading = false;
      },
      error: (error: any) => {
        this.loading = false;
        console.error('Error loading users:', error.message);
      }
    });
  };

  showYesNo(answer: number): string {
    switch (answer) {
      case 0: return 'No';
      case 1: return 'Yes';
      case 2: return 'Need More Information';
      default: return 'N/A';
    }
  }

}
